import React from "react";
import { useSelector } from "react-redux";
import AccessDenied from "./AccessDenied";

const PermissionGate = ({ requiredPermissions = [], children }) => {
  const user = useSelector((state) => state?.user?.currentUser);
  const userPermissions = user?.permissions || [];
  const hasRequiredPermissions = user?.role === "admin"
    || requiredPermissions.length === 0
    || requiredPermissions.some((perm) => userPermissions.includes(perm));

  if (!hasRequiredPermissions) {
    return <AccessDenied />;
  }

  return <>{children}</>;
};

export default PermissionGate;
